import { createContext, useContext } from 'react';

/** Mobile AppBar control for scenario create / edit / view (steps drawer) */
export interface ScenarioWorkflowMobileNav {
  onOpen: () => void;
  /** Current step/section label (tooltip) */
  title: string;
  readOnly?: boolean;
}

export type ScenarioWorkflowMobileContextValue = {
  register: (nav: ScenarioWorkflowMobileNav | null) => void;
};

export const ScenarioWorkflowMobileContext = createContext<ScenarioWorkflowMobileContextValue | null>(null);

export function useScenarioWorkflowMobile(): ScenarioWorkflowMobileContextValue {
  const ctx = useContext(ScenarioWorkflowMobileContext);
  if (!ctx) {
    return { register: () => {} };
  }
  return ctx;
}
